import i18next from "i18next";
import I18NextVue from "i18next-vue";
import Backend from "i18next-http-backend";
import LanguageDetector from 'i18next-browser-languagedetector';

const languageDetector = new LanguageDetector();

export const i18nextPromise = i18next
    .use(Backend)
    .use(languageDetector)
    .init({
        debug: false,
        fallbackLng: 'en',
        supportedLngs: ['en', 'pt', 'es'],
        // Natural-language keys: sentences may contain "." and ":", which
        // i18next would otherwise treat as nested-key/namespace separators
        keySeparator: false,
        nsSeparator: false,
        backend: {
            loadPath: '/api/locales/{{lng}}',
        },
        detection: {
            order: ['localStorage', 'sessionStorage', 'navigator'],
            lookupLocalStorage: 'language',
            lookupSessionStorage: 'language',
        },
    });

export default function (app) {
    app.use(I18NextVue, { i18next });
    return app;
}